import React from 'react';
export function TermsOfService() {
  return <div className="text-gray-700 space-y-4" data-id="element-525">
      <h3 className="text-lg font-bold text-amber-900" data-id="element-526">
        Términos y Condiciones
      </h3>
      <p data-id="element-527">Última actualización: 1 de septiembre de 2024</p>
      <p data-id="element-528">
        Bienvenido a Método Milhojas Perfecta. Al acceder y utilizar nuestro
        sitio web y servicios, usted acepta cumplir y estar sujeto a los
        siguientes términos y condiciones de uso. Por favor, léalos
        cuidadosamente.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-529">1. Términos generales</h4>
      <p data-id="element-530">
        Al acceder a este sitio web, asumimos que acepta estos términos y
        condiciones en su totalidad. No continúe utilizando el sitio web de
        Método Milhojas Perfecta si no acepta todos los términos y condiciones
        establecidos en esta página.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-531">
        2. Propiedad intelectual
      </h4>
      <p data-id="element-532">
        A menos que se indique lo contrario, Método Milhojas Perfecta y/o sus
        licenciantes poseen los derechos de propiedad intelectual de todo el
        material en este sitio. Todos los derechos de propiedad intelectual
        están reservados. Puede ver y/o imprimir páginas de este sitio para su
        uso personal, sujeto a las restricciones establecidas en estos términos
        y condiciones.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-533">3. Restricciones</h4>
      <p data-id="element-534">Está específicamente restringido de:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-535">
        <li data-id="element-536">
          Publicar cualquier material del sitio web en cualquier otro medio.
        </li>
        <li data-id="element-537">
          Vender, sublicenciar y/o comercializar cualquier material del sitio
          web.
        </li>
        <li data-id="element-538">
          Reproducir, duplicar o copiar material del sitio web con fines
          comerciales.
        </li>
        <li data-id="element-539">
          Redistribuir contenido de Método Milhojas Perfecta (a menos que el
          contenido esté específicamente hecho para redistribución).
        </li>
        <li data-id="element-540">
          Compartir sus credenciales de acceso a cursos y materiales con
          terceros.
        </li>
      </ul>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-541">4. Compras y pagos</h4>
      <p data-id="element-542">Al realizar una compra en nuestro sitio:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-543">
        <li data-id="element-544">
          Garantiza que está legalmente capacitado para realizar contratos
          vinculantes.
        </li>
        <li data-id="element-545">
          Acepta proporcionar información de pago verdadera, precisa, actual y
          completa.
        </li>
        <li data-id="element-546">
          Reconoce que todos los pagos son procesados a través de plataformas de
          pago seguras de terceros.
        </li>
        <li data-id="element-547">
          Entiende que una vez completada la compra y proporcionado el acceso a
          contenidos digitales, no hay devoluciones disponibles salvo lo
          estipulado en nuestra política de reembolso.
        </li>
      </ul>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-548">
        5. Acceso a cursos y contenido
      </h4>
      <p data-id="element-549">
        Tras la compra exitosa, se le proporcionará acceso al contenido digital
        adquirido. Este acceso:
      </p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-550">
        <li data-id="element-551">Es para su uso personal y no transferible.</li>
        <li data-id="element-552">
          Puede tener un período de acceso limitado según lo especificado en la
          descripción del producto.
        </li>
        <li data-id="element-553">
          No incluye derechos para copiar, distribuir o vender el contenido a
          terceros.
        </li>
      </ul>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-554">
        6. Política de reembolso
      </h4>
      <p data-id="element-555">
        Ofrecemos una garantía de satisfacción de 7 días para nuestros cursos
        digitales. Si no está satisfecho con su compra, puede solicitar un
        reembolso dentro de los 7 días posteriores a la fecha de compra
        contactándonos a través de los canales proporcionados.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-556">
        7. Limitación de responsabilidad
      </h4>
      <p data-id="element-557">
        En ningún caso Método Milhojas Perfecta, ni sus directores, empleados o
        afiliados, serán responsables por cualquier daño indirecto, consecuente,
        especial, incidental o punitivo, incluyendo pérdida de beneficios,
        derivados de o relacionados con su uso del sitio o cualquier contenido o
        servicio obtenido del sitio.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-558">
        8. Cambios en los términos
      </h4>
      <p data-id="element-559">
        Nos reservamos el derecho de revisar estos términos en cualquier momento
        según sea necesario. Al utilizar este sitio web, usted acepta estar
        sujeto a la versión actual de estos términos y condiciones.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-560">9. Ley aplicable</h4>
      <p data-id="element-561">
        Estos términos y condiciones se rigen e interpretan de acuerdo con las
        leyes de Uruguay, y usted se somete irrevocablemente a la jurisdicción
        exclusiva de los tribunales en esa ubicación.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-562">10. Contacto</h4>
      <p data-id="element-563">
        Si tiene preguntas sobre estos términos y condiciones, puede
        contactarnos en:
        <br data-id="element-564" />
        Email: info@metodomilhojasperfecta.com
      </p>
    </div>;
}